<template>
<GmapMap
  :center="{lat:9.005401, lng:38.763611}"
  :zoom="13"
  map-type-id="terrain"
  style="width: 100%; height: 500px"
>
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position"
    :shape="shape"
  />
</GmapMap> 
</template>

<script>
export default {
    data: () => {
        return {
            markers: [{
            position: {
              lat: 9.032866,
              lng: 38.751520
            }
          }, {
            position: {
              lat: 9.022863,
              lng: 38.737107
            }
          },
          {
            position: {
              lat: 9.022863,
              lng: 38.737107
            }
          },{
            position: {
              lat: 9.003612,
              lng: 38.755056
            }
          },{
            position: {
              lat: 9.013446,
              lng: 38.738755
            }
          },{
            position: {
              lat: 9.017006,
              lng: 38.754198
            }
          }],
          shape: {
            coords: [10, 10, 10, 15, 15, 15, 15, 10],
            type: 'poly'
          },
        }
    }
}
</script>
